// Если уже соглашались с использованием куков,
// больше не показываем попап

(function($) {
    if ($.cookie) {
        const $disclaimer = $('.js-cookie-disclaimer');

        cookieDisclaimerBottomPosition();

        if ($.cookie('agree_use_cookie')) {
            $disclaimer.addClass('hidden');
        } else {
            $disclaimer.removeClass('hidden');
        }

        $('.js-cookie-disclaimer-agree').on('click', function() {
            $disclaimer.addClass('hidden');
            // max-age=max-age-in-seconds (e.g., 60*60*24*365 or 31536000 for a year)
            $.cookie('agree_use_cookie', '1', {expires: 365, path: '/' });
        });
    }
})(jQuery);


export function cookieDisclaimerBottomPosition() {
    const $footerWarningLabel = $('.js-footer-warning-label');
    const $productCardActions = $('.product-card-cart__actions');

    if ($('.js-cookie-disclaimer').length) {

        if ($productCardActions.length && App.W.width() < 1024) {
            let productCardActionsHeight = App.W.width() < 768 ? $productCardActions.innerHeight() - 50 : $productCardActions.innerHeight();
            $('.js-cookie-disclaimer').find('.cookie-disclaimer__text').css('margin-bottom', productCardActionsHeight + 10 + 'px');
        } else {
            if ($footerWarningLabel.length) {
                let warningDisclaimerHeight = $footerWarningLabel.innerHeight();
                $('.js-cookie-disclaimer').find('.cookie-disclaimer__text').css('bottom', warningDisclaimerHeight + 10 + 'px');
            } else {
                $('.js-cookie-disclaimer').find('.cookie-disclaimer__text').css('bottom', '8px');
            }
        }

        // если все дисклеймеры закрыты, то убираем отступ у плашки кукис и прижимаем ее к низу экрана
        if ($footerWarningLabel.length === $footerWarningLabel.filter('._closed').length && !$productCardActions.length) {
            $('.js-cookie-disclaimer').find('.cookie-disclaimer__text').removeAttr('style');
        }
    }
}
